var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssesment1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 94,
    viewBox: "0 0 188 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 94,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 29.3204C129.722 29.3204 158.68 58.2784 158.68 94H142.159C142.159 67.4023 120.598 45.8406 94 45.8406C67.4023 45.8406 45.8406 67.4023 45.8406 94H29.3204C29.3204 58.2784 58.2784 29.3204 94 29.3204Z",
    fill: "#9D48B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 0C145.915 4.53853e-06 188 42.0852 188 94H171.48C171.48 51.2091 136.791 16.5202 94 16.5202C51.2091 16.5202 16.5202 51.2091 16.5202 94H0C4.53853e-06 42.0852 42.0852 -4.53853e-06 94 0Z",
    fill: "#9D48B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 57.308C114.264 57.308 130.692 73.7356 130.692 94H114.172C114.172 82.8594 105.141 73.8282 94 73.8282C82.8595 73.8282 73.8282 82.8594 73.8282 94H57.308C57.308 73.7356 73.7356 57.308 94 57.308Z",
    fill: "#9D48B3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssesment1);
export default __webpack_public_path__ + "static/media/assesment-1.28ace2c4a248fc4ee23d8261e6ad5856.svg";
export { ForwardRef as ReactComponent };